<div class="coluna-de-alertas" *ngIf="alerts.length > 0">
  <div
  *ngFor="let alert of alerts"
  class="my-alert {{ cssClass(alert) }} alert-dismissable"
  >
    <a class="close-btn" (click)="removeAlert(alert)">
      <i class="far fa-times"></i>
    </a>
    <i class="fas" [ngClass]="iconCssClass(alert)"></i>
    <h4 class="alert-title">{{ alert.title }}</h4>
    <p class="msg">{{ alert.message }}</p>
  </div>
</div>
